import React from 'react';
import I18n from '../../components/i18n';
import Icon from '../../components/icon';
import {Link} from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="text-center not-found-view">
      <div className="title">
        <img className="logo" src={`${process.env.PUBLIC_URL}/images/vht_logo.svg`} alt="VHT" />
      </div>
      <h2>
        <I18n t="page-not-found" />
      </h2>
      <Link to="/">
        <Icon icon="home" /> <I18n t="go-back-to-home" />
      </Link>
    </div>
  );
}
